@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_732_434_578)
public val Res.string.unknown: StringResource by lazy {
      StringResource("string:unknown", "unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374197, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532661, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343824, 27),
      ))
    }

@delegate:ResourceContentHash(-703_265_559)
public val Res.string.unknown_workplace: StringResource by lazy {
      StringResource("string:unknown_workplace", "unknown_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374151, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532591, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343774, 49),
      ))
    }

@delegate:ResourceContentHash(1_403_479_564)
public val Res.string.view_all: StringResource by lazy {
      StringResource("string:view_all", "view_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374225, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532701, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343852, 28),
      ))
    }

@delegate:ResourceContentHash(895_869_778)
public val Res.string.view_details: StringResource by lazy {
      StringResource("string:view_details", "view_details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374262, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532750, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343881, 36),
      ))
    }

@delegate:ResourceContentHash(1_933_682_254)
public val Res.string.voice_break_ended: StringResource by lazy {
      StringResource("string:voice_break_ended", "voice_break_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374299, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532795, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343918, 53),
      ))
    }

@delegate:ResourceContentHash(-912_250_555)
public val Res.string.voice_break_started: StringResource by lazy {
      StringResource("string:voice_break_started", "voice_break_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374353, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532869, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343972, 59),
      ))
    }

@delegate:ResourceContentHash(2_035_284_863)
public val Res.string.voice_cancelled: StringResource by lazy {
      StringResource("string:voice_cancelled", "voice_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374409, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532945, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344032, 67),
      ))
    }

@delegate:ResourceContentHash(-856_021_102)
public val Res.string.voice_clocked_in: StringResource by lazy {
      StringResource("string:voice_clocked_in", "voice_clocked_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374485, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533041, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344100, 56),
      ))
    }

@delegate:ResourceContentHash(1_033_532_445)
public val Res.string.voice_clocked_out: StringResource by lazy {
      StringResource("string:voice_clocked_out", "voice_clocked_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374534, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533110, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344157, 57),
      ))
    }

@delegate:ResourceContentHash(1_743_668_293)
public val Res.string.voice_confirm_clock_in: StringResource by lazy {
      StringResource("string:voice_confirm_clock_in", "voice_confirm_clock_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374584, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533180, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344215, 70),
      ))
    }

@delegate:ResourceContentHash(377_570_618)
public val Res.string.voice_confirm_clock_out: StringResource by lazy {
      StringResource("string:voice_confirm_clock_out", "voice_confirm_clock_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374663, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533275, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344286, 75),
      ))
    }

@delegate:ResourceContentHash(2_048_902_594)
public val Res.string.voice_confirm_end_break: StringResource by lazy {
      StringResource("string:voice_confirm_end_break", "voice_confirm_end_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374743, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533379, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344362, 75),
      ))
    }

@delegate:ResourceContentHash(-1_335_490_113)
public val Res.string.voice_confirm_start_break: StringResource by lazy {
      StringResource("string:voice_confirm_start_break", "voice_confirm_start_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374827, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533487, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344438, 77),
      ))
    }

@delegate:ResourceContentHash(-789_354_644)
public val Res.string.voice_free_tomorrow: StringResource by lazy {
      StringResource("string:voice_free_tomorrow", "voice_free_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374913, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533589, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344516, 71),
      ))
    }

@delegate:ResourceContentHash(-1_032_883_764)
public val Res.string.voice_next_shift: StringResource by lazy {
      StringResource("string:voice_next_shift", "voice_next_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375081, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533825, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344676, 76),
      ))
    }

@delegate:ResourceContentHash(1_358_206_593)
public val Res.string.voice_next_shift_at: StringResource by lazy {
      StringResource("string:voice_next_shift_at", "voice_next_shift_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374977, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533689, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344588, 87),
      ))
    }

@delegate:ResourceContentHash(-25_199_820)
public val Res.string.voice_no_upcoming_shift: StringResource by lazy {
      StringResource("string:voice_no_upcoming_shift", "voice_no_upcoming_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375162, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 533926, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344753, 71),
      ))
    }

@delegate:ResourceContentHash(1_550_883_406)
public val Res.string.voice_shift_hours: StringResource by lazy {
      StringResource("string:voice_shift_hours", "voice_shift_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375299, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534107, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344882, 41),
      ))
    }

@delegate:ResourceContentHash(1_263_268_828)
public val Res.string.voice_shift_hours_at: StringResource by lazy {
      StringResource("string:voice_shift_hours_at", "voice_shift_hours_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375234, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534030, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344825, 56),
      ))
    }

@delegate:ResourceContentHash(1_818_409_645)
public val Res.string.voice_shifts_and: StringResource by lazy {
      StringResource("string:voice_shifts_and", "voice_shifts_and", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375341, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534149, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344924, 44),
      ))
    }

@delegate:ResourceContentHash(-1_090_155_027)
public val Res.string.voice_signed_out: StringResource by lazy {
      StringResource("string:voice_signed_out", "voice_signed_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375382, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534190, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344969, 60),
      ))
    }

@delegate:ResourceContentHash(482_659_589)
public val Res.string.voice_title_clock_in: StringResource by lazy {
      StringResource("string:voice_title_clock_in", "voice_title_clock_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375451, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534267, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345030, 44),
      ))
    }

@delegate:ResourceContentHash(-1_040_718_978)
public val Res.string.voice_title_clock_out: StringResource by lazy {
      StringResource("string:voice_title_clock_out", "voice_title_clock_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375504, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534332, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345075, 45),
      ))
    }

@delegate:ResourceContentHash(-1_742_933_570)
public val Res.string.voice_title_end_break: StringResource by lazy {
      StringResource("string:voice_title_end_break", "voice_title_end_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375554, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534406, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345121, 41),
      ))
    }

@delegate:ResourceContentHash(-956_648_417)
public val Res.string.voice_title_next_shift: StringResource by lazy {
      StringResource("string:voice_title_next_shift", "voice_title_next_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375608, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534480, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345163, 46),
      ))
    }

@delegate:ResourceContentHash(-668_493_280)
public val Res.string.voice_title_start_break: StringResource by lazy {
      StringResource("string:voice_title_start_break", "voice_title_start_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375663, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534547, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345210, 47),
      ))
    }

@delegate:ResourceContentHash(-1_378_004_027)
public val Res.string.voice_title_work_tomorrow: StringResource by lazy {
      StringResource("string:voice_title_work_tomorrow", "voice_title_work_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375723, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534615, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345258, 61),
      ))
    }

@delegate:ResourceContentHash(931_349_219)
public val Res.string.voice_today: StringResource by lazy {
      StringResource("string:voice_today", "voice_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375785, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534697, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345320, 27),
      ))
    }

@delegate:ResourceContentHash(-269_149_155)
public val Res.string.voice_tomorrow: StringResource by lazy {
      StringResource("string:voice_tomorrow", "voice_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375813, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534741, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345348, 34),
      ))
    }

@delegate:ResourceContentHash(-1_237_696_056)
public val Res.string.voice_work_tomorrow: StringResource by lazy {
      StringResource("string:voice_work_tomorrow", "voice_work_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375844, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534780, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345383, 67),
      ))
    }

@delegate:ResourceContentHash(1_183_243_808)
public val Res.string.voice_working_now: StringResource by lazy {
      StringResource("string:voice_working_now", "voice_working_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375997, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534993, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345536, 69),
      ))
    }

@delegate:ResourceContentHash(80_984_955)
public val Res.string.voice_working_now_at: StringResource by lazy {
      StringResource("string:voice_working_now_at", "voice_working_now_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 375908, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 534872, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345451, 84),
      ))
    }

@delegate:ResourceContentHash(-36_185_323)
public val Res.string.weather_attribution_imgw: StringResource by lazy {
      StringResource("string:weather_attribution_imgw", "weather_attribution_imgw", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376067, 336),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535079, 364),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345606, 344),
      ))
    }

@delegate:ResourceContentHash(448_703_260)
public val Res.string.weather_attribution_met: StringResource by lazy {
      StringResource("string:weather_attribution_met", "weather_attribution_met", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376404, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535444, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 345951, 175),
      ))
    }

@delegate:ResourceContentHash(-809_148_931)
public val Res.string.weather_cloudy: StringResource by lazy {
      StringResource("string:weather_cloudy", "weather_cloudy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376584, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535656, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346127, 30),
      ))
    }

@delegate:ResourceContentHash(-882_475_601)
public val Res.string.weather_degrees: StringResource by lazy {
      StringResource("string:weather_degrees", "weather_degrees", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376619, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535695, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346158, 31),
      ))
    }

@delegate:ResourceContentHash(1_351_587_545)
public val Res.string.weather_forecast_description: StringResource by lazy {
      StringResource("string:weather_forecast_description", "weather_forecast_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376651, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535727, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346190, 80),
      ))
    }

@delegate:ResourceContentHash(-1_277_455_815)
public val Res.string.weather_forecast_marker: StringResource by lazy {
      StringResource("string:weather_forecast_marker", "weather_forecast_marker", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376736, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535828, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346271, 43),
      ))
    }

@delegate:ResourceContentHash(575_411_373)
public val Res.string.weather_observed_description: StringResource by lazy {
      StringResource("string:weather_observed_description", "weather_observed_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376780, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535880, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346315, 80),
      ))
    }

@delegate:ResourceContentHash(-478_369_385)
public val Res.string.weather_partly_cloudy: StringResource by lazy {
      StringResource("string:weather_partly_cloudy", "weather_partly_cloudy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376861, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 535977, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346396, 49),
      ))
    }

@delegate:ResourceContentHash(533_305_806)
public val Res.string.weather_precipitation: StringResource by lazy {
      StringResource("string:weather_precipitation", "weather_precipitation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376988, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536144, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346511, 41),
      ))
    }

@delegate:ResourceContentHash(-369_348_649)
public val Res.string.weather_precipitation_chance: StringResource by lazy {
      StringResource("string:weather_precipitation_chance", "weather_precipitation_chance", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 376923, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536051, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346446, 64),
      ))
    }

@delegate:ResourceContentHash(1_851_207_928)
public val Res.string.weather_rain: StringResource by lazy {
      StringResource("string:weather_rain", "weather_rain", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377030, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536186, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346553, 28),
      ))
    }

@delegate:ResourceContentHash(1_674_360_039)
public val Res.string.weather_range: StringResource by lazy {
      StringResource("string:weather_range", "weather_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377059, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536215, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346582, 41),
      ))
    }

@delegate:ResourceContentHash(1_951_433_528)
public val Res.string.weather_snow: StringResource by lazy {
      StringResource("string:weather_snow", "weather_snow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377101, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536257, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346624, 28),
      ))
    }

@delegate:ResourceContentHash(-1_936_752_903)
public val Res.string.weather_storm: StringResource by lazy {
      StringResource("string:weather_storm", "weather_storm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377130, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536290, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346653, 29),
      ))
    }

@delegate:ResourceContentHash(698_731_240)
public val Res.string.weather_strip_empty: StringResource by lazy {
      StringResource("string:weather_strip_empty", "weather_strip_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377160, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536328, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346683, 119),
      ))
    }

@delegate:ResourceContentHash(2_026_551_020)
public val Res.string.weather_strip_title: StringResource by lazy {
      StringResource("string:weather_strip_title", "weather_strip_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377284, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536532, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346803, 63),
      ))
    }

@delegate:ResourceContentHash(-131_274_178)
public val Res.string.weather_sunny: StringResource by lazy {
      StringResource("string:weather_sunny", "weather_sunny", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377348, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536620, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346867, 29),
      ))
    }

@delegate:ResourceContentHash(1_541_822_033)
public val Res.string.weather_unknown: StringResource by lazy {
      StringResource("string:weather_unknown", "weather_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377386, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536662, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346897, 35),
      ))
    }

@delegate:ResourceContentHash(93_099_842)
public val Res.string.whats_new_employee_1: StringResource by lazy {
      StringResource("string:whats_new_employee_1", "whats_new_employee_1", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377418, 200),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536702, 284),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346933, 188),
      ))
    }

@delegate:ResourceContentHash(-175_948_332)
public val Res.string.whats_new_employee_2: StringResource by lazy {
      StringResource("string:whats_new_employee_2", "whats_new_employee_2", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377619, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 536987, 264),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 347122, 156),
      ))
    }

@delegate:ResourceContentHash(762_379_711)
public val Res.string.whats_new_employee_3: StringResource by lazy {
      StringResource("string:whats_new_employee_3", "whats_new_employee_3", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377780, 164),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 537252, 292),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 347279, 148),
      ))
    }

@delegate:ResourceContentHash(-1_084_035_819)
public val Res.string.whats_new_employee_4: StringResource by lazy {
      StringResource("string:whats_new_employee_4", "whats_new_employee_4", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 377945, 220),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 537545, 384),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 347428, 200),
      ))
    }

@delegate:ResourceContentHash(1_062_776_300)
public val Res.string.whats_new_employee_5: StringResource by lazy {
      StringResource("string:whats_new_employee_5", "whats_new_employee_5", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 378166, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 537930, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 347629, 120),
      ))
    }

@delegate:ResourceContentHash(933_872_575)
public val Res.string.whats_new_manager_1: StringResource by lazy {
      StringResource("string:whats_new_manager_1", "whats_new_manager_1", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 378295, 235),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 538119, 343),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 347750, 215),
      ))
    }

@delegate:ResourceContentHash(97_879_062)
public val Res.string.whats_new_manager_2: StringResource by lazy {
      StringResource("string:whats_new_manager_2", "whats_new_manager_2", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 378531, 187),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 538463, 263),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 347966, 159),
      ))
    }

@delegate:ResourceContentHash(843_208_473)
public val Res.string.whats_new_manager_3: StringResource by lazy {
      StringResource("string:whats_new_manager_3", "whats_new_manager_3", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 378719, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 538727, 303),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348126, 171),
      ))
    }

@delegate:ResourceContentHash(-899_717_015)
public val Res.string.whats_new_manager_4: StringResource by lazy {
      StringResource("string:whats_new_manager_4", "whats_new_manager_4", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 378899, 211),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 539031, 371),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348298, 191),
      ))
    }

@delegate:ResourceContentHash(-1_811_354_281)
public val Res.string.whats_new_manager_5: StringResource by lazy {
      StringResource("string:whats_new_manager_5", "whats_new_manager_5", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379111, 155),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 539403, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348490, 147),
      ))
    }

@delegate:ResourceContentHash(1_224_487_828)
public val Res.string.whats_new_open: StringResource by lazy {
      StringResource("string:whats_new_open", "whats_new_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379335, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 539743, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348706, 62),
      ))
    }

@delegate:ResourceContentHash(217_772_074)
public val Res.string.whats_new_open_desc: StringResource by lazy {
      StringResource("string:whats_new_open_desc", "whats_new_open_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379267, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 539647, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348638, 67),
      ))
    }

@delegate:ResourceContentHash(1_488_575_990)
public val Res.string.whats_new_subtitle: StringResource by lazy {
      StringResource("string:whats_new_subtitle", "whats_new_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379390, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 539822, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348769, 62),
      ))
    }

@delegate:ResourceContentHash(-1_285_378_625)
public val Res.string.whats_new_title: StringResource by lazy {
      StringResource("string:whats_new_title", "whats_new_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379445, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 539893, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348832, 39),
      ))
    }

@delegate:ResourceContentHash(-491_353_087)
public val Res.string.who_worked_hint: StringResource by lazy {
      StringResource("string:who_worked_hint", "who_worked_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379481, 143),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 539941, 207),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348872, 103),
      ))
    }

@delegate:ResourceContentHash(1_901_684_896)
public val Res.string.who_worked_missing_rates: StringResource by lazy {
      StringResource("string:who_worked_missing_rates", "who_worked_missing_rates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379625, 192),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 540149, 328),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348976, 184),
      ))
    }

@delegate:ResourceContentHash(-570_163_254)
public val Res.string.who_worked_no_staff: StringResource by lazy {
      StringResource("string:who_worked_no_staff", "who_worked_no_staff", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379818, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 540478, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349161, 75),
      ))
    }

@delegate:ResourceContentHash(-485_013_465)
public val Res.string.who_worked_nobody: StringResource by lazy {
      StringResource("string:who_worked_nobody", "who_worked_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380080, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 540816, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349375, 45),
      ))
    }

@delegate:ResourceContentHash(-1_358_809_051)
public val Res.string.who_worked_nobody_done: StringResource by lazy {
      StringResource("string:who_worked_nobody_done", "who_worked_nobody_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 379914, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 540590, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349237, 74),
      ))
    }

@delegate:ResourceContentHash(1_909_889_616)
public val Res.string.who_worked_nobody_recorded: StringResource by lazy {
      StringResource("string:who_worked_nobody_recorded", "who_worked_nobody_recorded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380009, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 540725, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349312, 62),
      ))
    }

@delegate:ResourceContentHash(1_262_523_787)
public val Res.string.who_worked_pick: StringResource by lazy {
      StringResource("string:who_worked_pick", "who_worked_pick", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380238, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541026, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349513, 43),
      ))
    }

@delegate:ResourceContentHash(2_138_250_650)
public val Res.string.who_worked_pick_description: StringResource by lazy {
      StringResource("string:who_worked_pick_description", "who_worked_pick_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380130, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 540886, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349421, 91),
      ))
    }

@delegate:ResourceContentHash(-304_852_402)
public val Res.string.who_worked_recorded: StringResource by lazy {
      StringResource("string:who_worked_recorded", "who_worked_recorded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380282, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541086, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349557, 103),
      ))
    }

@delegate:ResourceContentHash(1_499_067_825)
public val Res.string.who_worked_shift: StringResource by lazy {
      StringResource("string:who_worked_shift", "who_worked_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380414, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541278, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349661, 64),
      ))
    }

@delegate:ResourceContentHash(1_979_980_481)
public val Res.string.who_worked_title: StringResource by lazy {
      StringResource("string:who_worked_title", "who_worked_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380499, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541363, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349726, 56),
      ))
    }

@delegate:ResourceContentHash(1_727_664_736)
public val Res.string.wide_pick_absence: StringResource by lazy {
      StringResource("string:wide_pick_absence", "wide_pick_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380564, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541452, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349783, 81),
      ))
    }

@delegate:ResourceContentHash(-1_482_228_108)
public val Res.string.wide_pick_day_record: StringResource by lazy {
      StringResource("string:wide_pick_day_record", "wide_pick_day_record", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380662, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541586, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349865, 108),
      ))
    }

@delegate:ResourceContentHash(-1_833_507_109)
public val Res.string.wide_pick_employee: StringResource by lazy {
      StringResource("string:wide_pick_employee", "wide_pick_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380779, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541775, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349974, 82),
      ))
    }

@delegate:ResourceContentHash(-1_537_430_330)
public val Res.string.wide_pick_notification: StringResource by lazy {
      StringResource("string:wide_pick_notification", "wide_pick_notification", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380874, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 541902, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350057, 82),
      ))
    }

@delegate:ResourceContentHash(1_991_515_970)
public val Res.string.wide_pick_shift: StringResource by lazy {
      StringResource("string:wide_pick_shift", "wide_pick_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 380969, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542037, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350140, 87),
      ))
    }

@delegate:ResourceContentHash(938_291_517)
public val Res.string.work_hours_actual: StringResource by lazy {
      StringResource("string:work_hours_actual", "work_hours_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381069, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542177, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350228, 41),
      ))
    }

@delegate:ResourceContentHash(204_683_908)
public val Res.string.work_hours_as_clocked: StringResource by lazy {
      StringResource("string:work_hours_as_clocked", "work_hours_as_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381115, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542231, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350270, 45),
      ))
    }

@delegate:ResourceContentHash(-556_059_243)
public val Res.string.work_hours_as_planned: StringResource by lazy {
      StringResource("string:work_hours_as_planned", "work_hours_as_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381161, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542293, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350316, 45),
      ))
    }

@delegate:ResourceContentHash(406_390_579)
public val Res.string.work_hours_change: StringResource by lazy {
      StringResource("string:work_hours_change", "work_hours_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381215, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542347, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350362, 33),
      ))
    }

@delegate:ResourceContentHash(621_206_294)
public val Res.string.work_hours_clocked: StringResource by lazy {
      StringResource("string:work_hours_clocked", "work_hours_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381249, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542397, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350396, 42),
      ))
    }

@delegate:ResourceContentHash(-1_892_516_902)
public val Res.string.work_hours_confirm_day: StringResource by lazy {
      StringResource("string:work_hours_confirm_day", "work_hours_confirm_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381436, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542624, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350539, 46),
      ))
    }

@delegate:ResourceContentHash(286_659_524)
public val Res.string.work_hours_confirm_day_hint: StringResource by lazy {
      StringResource("string:work_hours_confirm_day_hint", "work_hours_confirm_day_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381304, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542456, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350439, 99),
      ))
    }

@delegate:ResourceContentHash(168_122_983)
public val Res.string.work_hours_confirm_reported: StringResource by lazy {
      StringResource("string:work_hours_confirm_reported", "work_hours_confirm_reported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381491, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542699, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350586, 47),
      ))
    }

@delegate:ResourceContentHash(342_582_819)
public val Res.string.work_hours_day_confirmed: StringResource by lazy {
      StringResource("string:work_hours_day_confirmed", "work_hours_day_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381543, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542767, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350634, 44),
      ))
    }

@delegate:ResourceContentHash(1_700_684_447)
public val Res.string.work_hours_day_no_shifts: StringResource by lazy {
      StringResource("string:work_hours_day_no_shifts", "work_hours_day_no_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381592, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542832, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350679, 44),
      ))
    }

@delegate:ResourceContentHash(1_154_371_202)
public val Res.string.work_hours_day_not_over: StringResource by lazy {
      StringResource("string:work_hours_day_not_over", "work_hours_day_not_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381641, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542893, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350724, 47),
      ))
    }

@delegate:ResourceContentHash(1_542_624_590)
public val Res.string.work_hours_day_to_confirm: StringResource by lazy {
      StringResource("string:work_hours_day_to_confirm", "work_hours_day_to_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381709, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 542965, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350772, 53),
      ))
    }

@delegate:ResourceContentHash(-1_126_926_733)
public val Res.string.work_hours_days: StringResource by lazy {
      StringResource("string:work_hours_days", "work_hours_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381771, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543047, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350826, 31),
      ))
    }

@delegate:ResourceContentHash(-1_978_741_921)
public val Res.string.work_hours_done_day: StringResource by lazy {
      StringResource("string:work_hours_done_day", "work_hours_done_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381799, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543079, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350858, 59),
      ))
    }

@delegate:ResourceContentHash(1_752_006_563)
public val Res.string.work_hours_done_one: StringResource by lazy {
      StringResource("string:work_hours_done_one", "work_hours_done_one", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381863, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543163, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350918, 47),
      ))
    }

@delegate:ResourceContentHash(767_254_883)
public val Res.string.work_hours_done_partly: StringResource by lazy {
      StringResource("string:work_hours_done_partly", "work_hours_done_partly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 381919, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543243, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350966, 90),
      ))
    }

@delegate:ResourceContentHash(-345_417_159)
public val Res.string.work_hours_edit: StringResource by lazy {
      StringResource("string:work_hours_edit", "work_hours_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382124, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543516, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351159, 31),
      ))
    }

@delegate:ResourceContentHash(-1_843_856_791)
public val Res.string.work_hours_edit_planned: StringResource by lazy {
      StringResource("string:work_hours_edit_planned", "work_hours_edit_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382014, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543374, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351057, 47),
      ))
    }

@delegate:ResourceContentHash(411_672_402)
public val Res.string.work_hours_edit_title: StringResource by lazy {
      StringResource("string:work_hours_edit_title", "work_hours_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382066, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543442, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351105, 53),
      ))
    }

@delegate:ResourceContentHash(-891_777_326)
public val Res.string.work_hours_error_already_confirmed: StringResource by lazy {
      StringResource("string:work_hours_error_already_confirmed", "work_hours_error_already_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382156, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543560, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351191, 102),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString45Resources(map: MutableMap<String, StringResource>) {
  map.put("unknown", Res.string.unknown)
  map.put("unknown_workplace", Res.string.unknown_workplace)
  map.put("view_all", Res.string.view_all)
  map.put("view_details", Res.string.view_details)
  map.put("voice_break_ended", Res.string.voice_break_ended)
  map.put("voice_break_started", Res.string.voice_break_started)
  map.put("voice_cancelled", Res.string.voice_cancelled)
  map.put("voice_clocked_in", Res.string.voice_clocked_in)
  map.put("voice_clocked_out", Res.string.voice_clocked_out)
  map.put("voice_confirm_clock_in", Res.string.voice_confirm_clock_in)
  map.put("voice_confirm_clock_out", Res.string.voice_confirm_clock_out)
  map.put("voice_confirm_end_break", Res.string.voice_confirm_end_break)
  map.put("voice_confirm_start_break", Res.string.voice_confirm_start_break)
  map.put("voice_free_tomorrow", Res.string.voice_free_tomorrow)
  map.put("voice_next_shift", Res.string.voice_next_shift)
  map.put("voice_next_shift_at", Res.string.voice_next_shift_at)
  map.put("voice_no_upcoming_shift", Res.string.voice_no_upcoming_shift)
  map.put("voice_shift_hours", Res.string.voice_shift_hours)
  map.put("voice_shift_hours_at", Res.string.voice_shift_hours_at)
  map.put("voice_shifts_and", Res.string.voice_shifts_and)
  map.put("voice_signed_out", Res.string.voice_signed_out)
  map.put("voice_title_clock_in", Res.string.voice_title_clock_in)
  map.put("voice_title_clock_out", Res.string.voice_title_clock_out)
  map.put("voice_title_end_break", Res.string.voice_title_end_break)
  map.put("voice_title_next_shift", Res.string.voice_title_next_shift)
  map.put("voice_title_start_break", Res.string.voice_title_start_break)
  map.put("voice_title_work_tomorrow", Res.string.voice_title_work_tomorrow)
  map.put("voice_today", Res.string.voice_today)
  map.put("voice_tomorrow", Res.string.voice_tomorrow)
  map.put("voice_work_tomorrow", Res.string.voice_work_tomorrow)
  map.put("voice_working_now", Res.string.voice_working_now)
  map.put("voice_working_now_at", Res.string.voice_working_now_at)
  map.put("weather_attribution_imgw", Res.string.weather_attribution_imgw)
  map.put("weather_attribution_met", Res.string.weather_attribution_met)
  map.put("weather_cloudy", Res.string.weather_cloudy)
  map.put("weather_degrees", Res.string.weather_degrees)
  map.put("weather_forecast_description", Res.string.weather_forecast_description)
  map.put("weather_forecast_marker", Res.string.weather_forecast_marker)
  map.put("weather_observed_description", Res.string.weather_observed_description)
  map.put("weather_partly_cloudy", Res.string.weather_partly_cloudy)
  map.put("weather_precipitation", Res.string.weather_precipitation)
  map.put("weather_precipitation_chance", Res.string.weather_precipitation_chance)
  map.put("weather_rain", Res.string.weather_rain)
  map.put("weather_range", Res.string.weather_range)
  map.put("weather_snow", Res.string.weather_snow)
  map.put("weather_storm", Res.string.weather_storm)
  map.put("weather_strip_empty", Res.string.weather_strip_empty)
  map.put("weather_strip_title", Res.string.weather_strip_title)
  map.put("weather_sunny", Res.string.weather_sunny)
  map.put("weather_unknown", Res.string.weather_unknown)
  map.put("whats_new_employee_1", Res.string.whats_new_employee_1)
  map.put("whats_new_employee_2", Res.string.whats_new_employee_2)
  map.put("whats_new_employee_3", Res.string.whats_new_employee_3)
  map.put("whats_new_employee_4", Res.string.whats_new_employee_4)
  map.put("whats_new_employee_5", Res.string.whats_new_employee_5)
  map.put("whats_new_manager_1", Res.string.whats_new_manager_1)
  map.put("whats_new_manager_2", Res.string.whats_new_manager_2)
  map.put("whats_new_manager_3", Res.string.whats_new_manager_3)
  map.put("whats_new_manager_4", Res.string.whats_new_manager_4)
  map.put("whats_new_manager_5", Res.string.whats_new_manager_5)
  map.put("whats_new_open", Res.string.whats_new_open)
  map.put("whats_new_open_desc", Res.string.whats_new_open_desc)
  map.put("whats_new_subtitle", Res.string.whats_new_subtitle)
  map.put("whats_new_title", Res.string.whats_new_title)
  map.put("who_worked_hint", Res.string.who_worked_hint)
  map.put("who_worked_missing_rates", Res.string.who_worked_missing_rates)
  map.put("who_worked_no_staff", Res.string.who_worked_no_staff)
  map.put("who_worked_nobody", Res.string.who_worked_nobody)
  map.put("who_worked_nobody_done", Res.string.who_worked_nobody_done)
  map.put("who_worked_nobody_recorded", Res.string.who_worked_nobody_recorded)
  map.put("who_worked_pick", Res.string.who_worked_pick)
  map.put("who_worked_pick_description", Res.string.who_worked_pick_description)
  map.put("who_worked_recorded", Res.string.who_worked_recorded)
  map.put("who_worked_shift", Res.string.who_worked_shift)
  map.put("who_worked_title", Res.string.who_worked_title)
  map.put("wide_pick_absence", Res.string.wide_pick_absence)
  map.put("wide_pick_day_record", Res.string.wide_pick_day_record)
  map.put("wide_pick_employee", Res.string.wide_pick_employee)
  map.put("wide_pick_notification", Res.string.wide_pick_notification)
  map.put("wide_pick_shift", Res.string.wide_pick_shift)
  map.put("work_hours_actual", Res.string.work_hours_actual)
  map.put("work_hours_as_clocked", Res.string.work_hours_as_clocked)
  map.put("work_hours_as_planned", Res.string.work_hours_as_planned)
  map.put("work_hours_change", Res.string.work_hours_change)
  map.put("work_hours_clocked", Res.string.work_hours_clocked)
  map.put("work_hours_confirm_day", Res.string.work_hours_confirm_day)
  map.put("work_hours_confirm_day_hint", Res.string.work_hours_confirm_day_hint)
  map.put("work_hours_confirm_reported", Res.string.work_hours_confirm_reported)
  map.put("work_hours_day_confirmed", Res.string.work_hours_day_confirmed)
  map.put("work_hours_day_no_shifts", Res.string.work_hours_day_no_shifts)
  map.put("work_hours_day_not_over", Res.string.work_hours_day_not_over)
  map.put("work_hours_day_to_confirm", Res.string.work_hours_day_to_confirm)
  map.put("work_hours_days", Res.string.work_hours_days)
  map.put("work_hours_done_day", Res.string.work_hours_done_day)
  map.put("work_hours_done_one", Res.string.work_hours_done_one)
  map.put("work_hours_done_partly", Res.string.work_hours_done_partly)
  map.put("work_hours_edit", Res.string.work_hours_edit)
  map.put("work_hours_edit_planned", Res.string.work_hours_edit_planned)
  map.put("work_hours_edit_title", Res.string.work_hours_edit_title)
  map.put("work_hours_error_already_confirmed", Res.string.work_hours_error_already_confirmed)
}
